import { api } from '../api-client.config';

export const deleteFile = async (blobName: string): Promise<{ message: string }> => {
  return api.delete(`/files/${encodeURIComponent(blobName)}`);
};
